import { useEffect, useState } from 'react';

export function usePdfZoom(initialScale = 1.0) {
  const [zoomScale, setZoomScale] = useState(initialScale);

  const zoomIn = () => setZoomScale((prev) => Math.min(prev + 0.1, 3));
  const zoomOut = () => setZoomScale((prev) => Math.max(prev - 0.1, 0.5));

  useEffect(() => {
    setZoomScale(initialScale);
  }, [initialScale]);

  return { zoomScale, setZoomScale, zoomIn, zoomOut };
}
